<template>
  <div class="gl-loader">
    <img
      alt="loader"
      src="../../public/assets/img/Pre.gif"
      style="height: 50px"
    >
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#383c54",
    },
  },
}
</script>
